<div class="container">

    <div class="card col-6 p-0">
        <div class="card-header text-center">
            <img src="./assets/img/logo.png" alt="B5S" height="72">
        </div>
        <div class="card-body">
            <h4 class="card-title mb-4 mt-1">Entrar</h4>
            <form autocomplete="off">
                <input type="hidden" autocomplete="off">
                <div class="form-group">
                    <label>Email/Login</label>
                    <input name="" class="form-control" placeholder="Email" type="email" [formControl]="loginObj.email" required [class.is-invalid]="loginObj.email.invalid">
                    <div class="invalid-feedback" *ngIf="loginObj.email.invalid">
                        {{getErrorMessage()}}
                    </div>
                </div>
                <div class="form-group">
                    <label>Senha</label>
                    <input class="form-control" placeholder="Senha" type="password" [formControl]="loginObj.senha" required [class.is-invalid]="loginObj.senha.invalid" >
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-primary btn-block" (click)="submitLogin()"> Login  </button>
                </div>
            </form>
        </div>
        <div class="card-footer">
            <p>&copy; Billy The Ticket</p>
        </div>
    </div>
</div>
